import { useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod"
import * as z from "zod"
import FormSelect from "../shared/FormSelect";
import { loadRidersFromHrp } from "../../utils/optionLoaderUtils";
import FormInputAsycnPaginate from "../shared/FormInputAsycnPaginate";
import { fetchSyncRider } from "../../utils/apiUtils";
import { queryClient } from "../../App";

const schema = z.object({
    typeName: z.object(
        {
            label: z.string().describe("typeName"),
            value: z.string().describe("typeName"),
        },
        {
            error: (iss) => {
                // console.log('iss', iss);
                if (iss.code === "invalid_type") {
                    return "TypeName is required";
                }

                return "TypeName is required";
            },
        }
    ),
    rider: z.object(
        {
            label: z.string().describe("rider"),
            value: z.number(),
            additional: z.any()
        }
    )
})

const SyncData = ({ onSubmitHandler }) => {

    const {
        reset,
        register,
        handleSubmit,
        watch,
        control,
        formState: { errors, isDirty, isValid, isSubmitting, isSubmitted },
    } = useForm({
        resolver: zodResolver(schema),
        mode: 'onChange',
        defaultValues: {
            typeName: { value: 'BenefitPlanRider', label: 'BenefitPlanRider' },
            rider: null
        }
    })

    const onSubmit = async (data) => {

        await fetchSyncRider({
            typeName: data.typeName.value,
            benefitPlanRiderKey: data.rider.value
        })

        await queryClient.invalidateQueries({ refetchType: 'none' })

        reset()
        onSubmitHandler?.()
    }

    return (
        <>
            <p className="sub-title">Data should sync within 30 seconds.</p>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '1rem 1rem 1rem 0rem', }}>

                <form onSubmit={handleSubmit(onSubmit)} style={{ width: '50%' }}>

                    <FormSelect
                        label={'Type'}
                        name={'typeName'}
                        control={control}
                        options={[
                            //  { value: 'BenefitPlanTemplate', label: 'BenefitPlanTemplate' },
                            { value: 'BenefitPlanRider', label: 'BenefitPlanRider' },
                            //     { value: 'BenefitPlanComponent', label: 'BenefitPlanComponent' },

                        ]}
                        errors={errors}
                        placeholder="Select..."
                    />


                    <FormInputAsycnPaginate
                        label={"Rider"}
                        name={"rider"}
                        control={control}
                        loadOptions={loadRidersFromHrp}
                        errors={errors}

                        placeholder="Select a rider"
                    />




                    {isSubmitting ? <div className="loader" /> : <input className="btn" type="submit" value={'Sync'}
                        disabled={!isDirty || !isValid}
                    />}


                </form >


                {/* <ReactJson
                    style={{ padding: '1rem' }}
                    src={{ isSubmitted, isSubmitting }}
                    name={false}
                    collapsed={1}
                    collapseStringsAfterLength={150}
                    displayDataTypes={false}
                    displayObjectSize={false}
                    sortKeys={true}
                /> */}

            </div >
        </>

    )
}

export default SyncData